export default __webpack_public_path__ + "static/media/left-camels.fbcf249f.png";